import { Icon } from "@mui/material";
import React from "react";

const CustomIcon = ({ icon = "hotel", className = "", ...rest }) => {
  let IconFile = require("assets/icons/date.svg");
  try {
    IconFile = require(`assets/icons/${icon}.svg`);
  } catch (err) {
    console.error(`${icon} icon not found`);
  }

  return (
    <Icon className={`${className} icon`} {...rest}>
      <img style={{ height: "100%" }} src={IconFile} className="icon-img" alt="icon" />
    </Icon>
  );
};

export default CustomIcon;
